/*
 * "Update required": the app refusing to run on a native build the owner has
 * retired. See services/api/src/worx/nativeUpdate.ts for how the number is set.
 *
 * Fails OPEN everywhere. No plugin (an older binary), a failed lookup, a number
 * that is not a number: all mean "carry on". A gate that can lock people out by
 * mistake is worse than one that sometimes lets an old build through.
 */

/** True only when both numbers are real and the installed build is below the minimum. */
export function needsUpdate(installedBuild: string | number | null | undefined, minBuild: number | null | undefined): boolean {
  const installed = Number(installedBuild)
  const min = Number(minBuild)
  if (!Number.isFinite(installed) || !Number.isFinite(min)) return false
  if (installedBuild === null || installedBuild === undefined || installedBuild === '') return false
  return min > 0 && installed < min
}
